module.exports = __webpack_public_path__ + "static/media/destination-placeholder.3b3257ab.jpg";